"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retuenMiddlewareArray = void 0;

var _NotAMiddleware = require("../lib/Exceptions/NotAMiddleware");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var retuenMiddlewareArray = function retuenMiddlewareArray(x) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!Array.isArray(arr)) {
    throw new _NotAMiddleware.NotAMiddleware();
  } else {
    var allMiddlewares = arr.every(function (a) {
      return typeof a === 'function';
    });

    if (!allMiddlewares) {
      throw new _NotAMiddleware.NotAMiddleware();
    }
  }

  if (Array.isArray(x)) {
    if (x.length < 1) {
      return _toConsumableArray(arr);
    }

    var _allMiddlewares = x.every(function (_x) {
      return typeof _x === 'function';
    });

    if (_allMiddlewares) {
      return [].concat(_toConsumableArray(arr), _toConsumableArray(x));
    }

    throw new _NotAMiddleware.NotAMiddleware();
  }

  if (typeof x === 'function') {
    arr.push(x);
  } else {
    throw new _NotAMiddleware.NotAMiddleware();
  }

  return arr;
};

exports.retuenMiddlewareArray = retuenMiddlewareArray;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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